var GoogleCalendar = {
  init: function() {

  },
  getData: function() {
    var timestamp = localStorage.getItem('calendarTimestamp')
    var data = JSON.parse(localStorage.getItem('calendars'));
    if (!timestamp || +new Date() - timestamp >  1000) {
      if (data) data.expired = true;
    } 
    return  data;
  },
  setData: function (data) {
    localStorage.setItem('calendars', JSON.stringify(data));
    document.redraw()
  },
  clearData: function() {
    localStorage.removeItem('calendars')
  },
  calInfoRequest: function(calendarId) {
    return gapi.client.request({
      path: "calendar/v3/users/me/calendarList/" + (calendarId || "primary")
    });
  },
  calListRequest: function(calendarId) {
    return gapi.client.request({
      path: "calendar/v3/users/me/calendarList"
    });
  },
  options: {},
  calEventRequest: function(calendarId) {
    var today = new Date();
    today.setHours(0);
    today.setDate(today.getDate());
    var options = this.options;
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(23);
    var request  = {
      path: "calendar/v3/calendars/" + (calendarId || "primary") + "/events",
      params: {
        timeMin: (options.timeMin || today).toISOString(),
        timeMax: (options.timeMax || tomorrow).toISOString(),
        showDeleted: false,
        singleEvents: true,
        maxResults: options.maxResults || 2500,
        orderBy: "startTime"
      }
    }
    if (!gapi.client) return undefined;
    return gapi.client.request(request);
  },

  fetchIfNeeded: function() {
    if (!this.getData()) {
      this.fetch()
    }
  },
  fetching: false,
  fetch: function() {
    if (!gapi || !gapi.client) {
      return;
    }
    if (GoogleCalendar.fetching) {
      console.info("Calendar: Already fetching");
      return;
    }
    var year = new Date();
    year.setYear(year.getYear() + 1);
  
    var calendarIds = localStorage.getItem('calendarIds') || 'primary';

    calendarIds = calendarIds.split(/[ ,]+/);
    var batch = gapi.client.newBatch();
    batch.add(GoogleCalendar.calListRequest(), { id: "list" });
    document.setStatus("Downloading Calendar Info for ", calendarIds);
    calendarIds.forEach(function(calendarId) {
      batch.add(GoogleCalendar.calEventRequest(calendarId, GoogleCalendar.options), { id: calendarId });
      batch.add(GoogleCalendar.calInfoRequest(calendarId), { id: calendarId + "-info" });
    });

    GoogleCalendar.fetching = true;
    batch.then( function(batchResponse) {
      GoogleCalendar.fetching = false;

      document.setStatus("Downloaded Calendar Info");

      var info = batchResponse.result.list.result.items;
      var calendars = [];
      calendarIds.forEach(function(calendarId) {
        var response = batchResponse.result[calendarId];
        if (response.status == 401) {
          // chrome.identity.removeCachedAuthToken({ token: token });
          // throw "Token is invalid, removing cache";
        }
        var calendar = response.result;
        var info = batchResponse.result[calendarId + "-info"].result;
        for (var key in info) {
          calendar[key] = info[key];
        }
        calendars.push(calendar);
      });
  
      if (calendars) {
        localStorage.setItem('calendarTimestamp', +new Date())
        localStorage.setItem('calendarList', JSON.stringify(info))
        localStorage.setItem('calendars', JSON.stringify(calendars));
        console.info("Set Calendars", calendars)
        document.redraw()
      }
    });
  },
  downloadTimeout: null,
  scheduleTaskDownload: function() {
    clearTimeout(downloadTimeout);
    downloadTimeout = setTimeout(function(){
    downloadTimeout = null;
    downloadTasks()
  }, 5000);
}


}

  




module.exports = GoogleCalendar

